import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/src/app/[locale]/error.tsx");
